var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-upload',{staticClass:"button is-primary",attrs:{"extensions":"png","accept":"image/png"},on:{"input":_vm.uploadFile}},[_vm._v(" "+_vm._s(_vm.buttonTitle)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }